import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import {Box, Grid, IconButton} from "@mui/material";
import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
} from "../../grid/iLocalAGGrid";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";


class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      { id: "profile_id", numeric: false, disablePadding: false, label: "Profile", padding: '8px', field: 'profile_id' },
      { id: "email", numeric: false, disablePadding: false, label: "email", padding: '8px', field: 'email' },
      { id: "invoice_id", numeric: false, disablePadding: false, label: "Invoice", padding: '8px', field: 'invoice_id' },
      { id: "item_name", numeric: false, disablePadding: false, label: "Items", padding: '8px', field: 'item_name' },
      { id: "bin_id", numeric: false, disablePadding: false, label: t("Report.Assign.BIN"), padding: '8px', field: 'bin_id' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t("Report.Assign.StockCode"), padding: '8px', field: 'stock_code' },
      { id: "pickup_code", numeric: false, disablePadding: false, label: t("Report.Assign.PUCode"), padding: '8px', field: 'pickup_code' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Assign.Store"), padding: '8px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Assign.Location"), padding: '8px', field: 'name' },
      { id: "pickuped_date", numeric: false, disablePadding: false, label: t("Report.Picked.PickupDate"), padding: '8px', field: 'pickuped_date' },
    ];

    return (
      <TableHead>

        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                {[
                  "deliverytype",
                  "fillid",
                  "prescriptionnumber",
                  "OrderId",
                  "PrescriptionTxnId",
                  "ndccode",
                  "qty",
                  "price",
                  "createdon",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
  root: {
    width: "100%",
    // width: '94.6%'
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10'
  }
  ,
  padding10px: {
    padding: '8px'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper:
  {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869'
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
  hidden: {
    display: 'none'
  }
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'pickuped_date',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      dob: '',
      orderBy: "pickuped_date",
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      totalRecords: 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const {t} = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        console.log(storelist,"storelist");
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
        this.BindBoxesbyStoreId(storelist.map(x => x.id));
      });
    
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });
    TransactionFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
    
}

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/RetailPickupItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        let csvRow = [];
        let Array = [['ID', 'Profile Id', 'Email', 'Invoice Id', 'Items', 'Stock Code', 'Pickup Code', 'Bin Id','Store','Box','Stock Date', ]];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined) {
          if (result && result.length > 0) {
            for (let i of result) {
              Array.push(
                [
                  i.profile_id,
                  i.email,
                  i.invoice_id,
                  i.item_name,
                  i.stock_code,
                  i.pickup_code,
                  i.bin_id,
                  i.store,
                  i.box,
                  i.pickuped_date? this.convertToTimeZone(i && i.pickuped_date) : '',
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "RetailPickupItemsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
        this.setState({ loader: false });
      })
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['profile_id', 'email'].includes(field)) {
      tablename = 'icustomers';
    }
    if (['name'].includes(field)) {
      tablename = 'products';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === orderBy) {
      order = this.state.order === "asc" ? "desc" : "asc";
    } else if (this.state.order === order) {
      order = "asc";
    } else {
      order = "desc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    console.log(store_ids,"store_ids")
    if (store_ids.length > 0) {
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const {t} = this.props;
          let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          //const boxvalues = boxlist;
          this.setState({ chipboxes: [], nboxes: [], boxvalues: boxvalues });
        });
    }

  }
  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id)
        }
      }
    }
    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };
  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickuped_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  exportPDF = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'printAssignedItems', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then((response) => {
        try {
          return response.text()
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        let x = window.open('', 'title', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,top=100,left=145');
        x.document.write(res);
        x.document.close();
        setTimeout(() => {
          x.print();
          x.close();
          this.setState({ loader: false });
        }, 1300)
      })
      .catch((error) => {
        this.setState({ loader: false });
        console.error(error)
      })
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['pickuped_date'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "apis/i-ecom/orders/order/getPickedupitems", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'pickuped_date');
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };

  render() {
    const {classes, t} = this.props;
    return (
      <div>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <Box component="div">
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
              <Tooltip key="export-csv" title={t("Report.Assign.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  onClick={() => { this.exportCSV() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="export-pdf" title={t("Report.Assign.ExportPDFTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
        <Divider style={{ marginTop: '10px', height: '5px', borderColor: 'rgba(0, 0, 0, 0.12)', borderStyle: 'solid', borderBottomWidth: '5px' }} />
        <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'profile_id', headerName: "Profile", colId: 'profile_id' },
              { field: 'email', headerName: "email", colId: 'email' },
              { field: 'invoice_id', headerName: "Invoice", colId: 'invoice_id' },
              { field: 'item_name', headerName: "Items", colId: 'item_name' },
              { field: 'bin_id', headerName: t("Report.Assign.BIN"), colId: 'bin_id' },
              { field: 'stock_code', headerName: t("Report.Assign.StockCode"), colId: 'stock_code' },
              { field: 'pickup_code', headerName: t("Report.Assign.PUCode"), colId: 'pickup_code' },
              { field: 'store', headerName: t("Report.Assign.Store"), colId: 'store' },
              { field: 'box', headerName: t("Report.Assign.Location"), colId: 'box' },
              withDateColumnFilter({ field: 'pickuped_date', headerName: t("Report.Picked.PickupDate"), colId: 'pickuped_date',
                valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) => {
              const d = params.data || {};
              return String(d.invoice_id || d.profile_id || `${d.bin_id||''}-${d.pickuped_date||''}`);
            }}
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};


export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/retail-pickuped-items/index.js